import p5 from "p5"
window.p5 = p5

import { SVG } from "@svgdotjs/svg.js"
window.SVG = SVG

import "./planner/view"
